export default __webpack_public_path__ + "static/ethereum-45e1c64a1f4926f0669c350727f6bd75.png";